import { v4 as uuid } from 'uuid';
import { REFERENCE_LINE_DIRECTION, type ReferenceLine } from '@/version-types';

export const genReferenceLineId = () => {
    return 'ref_line_' + uuid();
};

export const getDefaultReferenceLine = (line?: Partial<ReferenceLine>): ReferenceLine => {
    return {
        id: line?.id || genReferenceLineId(),
        direction: line?.direction || REFERENCE_LINE_DIRECTION.HORIZONTAL,
        position: typeof line?.position === 'number' ? Math.round(line.position) : 0,
    };
};

export function getContainerRect() {
    const container =
        document.querySelector('[data-plugin="reference-lines"]') ||
        document.querySelector('[data-editor-id="editor-container"]') ||
        document.querySelector('.editor-plugin') ||
        document.querySelector('#editor-container') ||
        document.querySelector('.p-editor__stage-content') ||
        document.querySelector('.p-editor__stage') ||
        document.querySelector('.p-editor__stage-wrap');

    const containerRect = container?.getBoundingClientRect();
    return containerRect;
}
